<div class="loading-component" [ngClass]="topPaddingClass" *ngIf="loading" fxFlex="auto" fxLayoutAlign="center center">
	<img src="/assets/images/loading.gif" alt="loading..." style="max-width: 71px;">
</div>
